"use client";

import { Chip } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useImportationDetailsData from "@/hooks/data/use-importation-details-data";
import IImportationDetails from "@/interfaces/importation-details";
import { ImportationDetailsMessages } from "@/messages/importationDetails/importation-details.messages";

interface Props {
  importation: IImportationDetails;
  index: number;
  messages: ImportationDetailsMessages;
}

export function ImportationDetailsTableRow({ importation, index, messages }: Props) {
  const data = useImportationDetailsData({ importation, messages });

  return (
    <TableRow index={index}>
      <TableCell>{data.formattedCode}</TableCell>
      <TableCell>{data.formattedName}</TableCell>

      <TableCell>
        <Chip
          label={data.formattedStatus.toUpperCase()}
          color={data.isWarning ? undefined : data.bgColor}
          variant="outlined"
          sx={
            data.isWarning
              ? {
                  color: "#F9A825",
                  borderColor: "#F9A825",
                  "& .MuiChip-label": { color: "#F9A825" },
                }
              : undefined
          }
        />
      </TableCell>
      <TableCell>{data.formattedMessage}</TableCell>
    </TableRow>
  );
}
